import { get, post, put, search } from 'redux/shelf/api';
import { createReducer } from 'redux/shelf/reducer';
import session from 'lib/session';
import { field } from 'redux/shelf';

export const actions = {
  fetchHistory: get`feeds/${session.getMerchant}`(),
  pullFeed: post`feeds/${session.getMerchant}/pull`(),
  getFeedData: get`settings/${session.getMerchant}/feed`(field('feed')),
  updateFeedData: put`settings/${session.getMerchant}/feed`(field('feed')),
  getWebhookMetrics: get`product-analytics/webhook`(),
  getIndexMetrics: get`product-analytics/index`(),
  fetchLatestUpdatedProducts: search.post`search`(),
  loadMoreUpdatedProducts: search.post`search`(),
  searchProducts: search.post`search`(),
  scheduleFeedPull: put`settings/index-configuration/product-sync`(),
};

export const reducer = createReducer(actions, {
  [actions.fetchHistory]: (s, { payload, meta }) => ({
    ...s,
    history: payload.entity,
  }),
  [actions.getWebhookMetrics]: (s, { payload, meta }) => ({
    ...s,
    webhookMetrics: payload.entity,
  }),
  [actions.getIndexMetrics]: (s, { payload, meta }) => ({
    ...s,
    indexMetrics: payload.entity,
  }),
  [actions.fetchLatestUpdatedProducts]: (s, { payload, meta }) => ({
    ...s,
    latestUpdatedProducts: {
      list: s?.latestUpdatedProducts?.list?.length
        ? [...payload.entity.items, ...s.latestUpdatedProducts.list]
        : payload.entity.items,
      count: payload.entity.meta.total,
    },
  }),
  [actions.searchProducts]: (s, { payload, meta }) => ({
    ...s,
    searchedProducts: {
      list: payload.entity.items,
      count: payload.entity.meta.total,
    },
  }),
});
